import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AccSimpleInputTextFormControlInterface } from '../acc-simple-input-text-form.component';

@Component({
  selector: 'app-simple-form-date-input',
  templateUrl: './simple-form-date-input.component.html',
  styleUrls: ['./simple-form-date-input.component.scss']
})
export class SimpleFormDateInputComponent {

  @Input({ required: true }) public parentFormGroup!: FormGroup;
  @Input({ required: true }) public controlInfo!: AccSimpleInputTextFormControlInterface;
  @Input({ required: true }) public controlId!: string | number;

}
